import React, { useState } from 'react';
import './stylesheets/LandingPopup.css'; // Optional: external styles

function LandingPopup() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="landing-popup">
      <div className="landing-popup-content">
        <p className="landing-popup-text">
          Welcome!
        </p>
        <p className="landing-popup-text">
          This web app showcases 4 popular modern UI design styles, featuring my cat Cornbread. Enjoy!
        </p>
        <button className="landing-popup-close" onClick={() => setIsVisible(false)}>
          ✕
        </button>
      </div>
    </div>
  );
}

export default LandingPopup;
